import { useMutation } from "react-query";
import { Put } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";
import { useQueryClient } from "react-query";
import { Organization } from "../../types/api/User";

export default (org_id: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  return useMutation<Organization, null, Organization>(
    async (body: Organization) =>
      Put(`/api/organization/${org_id}`, await getAccessTokenSilently(), body),
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries([`organization_${org_id}`]);
      },
    }
  );
};
